import { choiceIconRegistry } from "../choiceIconRegistry";

const SvgWrapper = ({ children }: { children: React.ReactNode }) => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    width={32}
    height={32}
  >
    {children}
  </svg>
);

export const registerCommunicationChoiceIcons = () => {
  choiceIconRegistry.register(
    "sms",
    <SvgWrapper>
      <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17L4 17.17V4h16v12zM7 9h2v2H7V9zm4 0h2v2h-2V9zm4 0h2v2h-2V9z" />
    </SvgWrapper>,
  );

  choiceIconRegistry.register(
    "qrcode",
    <SvgWrapper>
      <path d="M3 11h8V3H3v8zm2-6h4v4H5V5zm8-2v8h8V3h-8zm6 6h-4V5h4v4zM3 21h8v-8H3v8zm2-6h4v4H5v-4zm13 2h-2v2h2v2h2v-4h-2zm0-4h2v2h-2v-2zm-4 4h2v4h-2v-4zm-2-2h2v2h-2v-2zm4 0h2v2h-2v-2zm2-2h2v2h-2v-2z" />
    </SvgWrapper>,
  );

  choiceIconRegistry.register(
    "envelope",
    <SvgWrapper>
      <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
    </SvgWrapper>,
  );
};
